export enum ArticleStatus {
  Writing = 0,
  Published = 1,
  WaitingForEditing = 2,
  Editing = 3,
  WaitingForJournalistEditing = 4,
  JournalistEditing = 5,
  WaitingForSubEditing = 6,
  SubEditing = 7,
  SubEditorApproved = 8,
}

export function GetArticleStatus(): string[] {
  return [
    'Writing',
    'Published',
    'Waiting For Editing',
    'Editing',
    'Waiting For Journalist Editing',
    'Journalist Editing',
    'Waiting for Sub-editing',
    'Sub-editing',
    'Sub-editor approved',
  ];
}
